// {
//   "name": "iconic-image-text-with-rotating-bar.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-rotating-bar')) {
    return;
  }

  class IconicImageTextwithRotatingBar extends HTMLElement {
    constructor() {
      super();
      this.scrollTopClass = 'scroll-top';
      this.scrollDownClass = 'scroll-down';
      this.lastScrollPosition = window.scrollY;
      
      window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    connectedCallback() {
      this.content = this.querySelectorAll('#marqueeContent'); // Adjust to select the content correctly
      // this.lastScrollPosition = window.scrollY;

      if (this.content) {
        // this.handleScroll();
        // window.addEventListener('scroll', this.handleScroll.bind(this));
      }

      window.addEventListener('resize', this.handleResize.bind(this));
      setTimeout(() => this.verticalRotatingBar(), 100); // Ensure it runs initially
    }

    // disconnectedCallback() {
    //   window.removeEventListener('scroll', this.handleScroll.bind(this));
    //   window.removeEventListener('resize', this.handleResize.bind(this));
    // }

    handleScroll() {
      if (!this.content) return;

      const currentScrollPosition = window.scrollY;
      this.content.forEach(content => {
        if (currentScrollPosition < this.lastScrollPosition) {
          content.classList.remove(this.scrollTopClass);
          content.classList.add(this.scrollDownClass);
        } else {
          content.classList.add(this.scrollTopClass);
          content.classList.remove(this.scrollDownClass);
        }
      });
      this.lastScrollPosition = currentScrollPosition;
    }

    handleResize() {
      setTimeout(() => this.verticalRotatingBar(), 100); // Ensures it runs after rendering
    }

    verticalRotatingBar() {
      setTimeout(() => {
        const body = this.closest(".iconic-image-with-text-content");
        if (!body) return;

        // Ensure the element is visible before measuring
        if (this.offsetParent === null) {
          return;
        }

        const { width: rotatingBarWidth, height: rotatingBarHeight } = this.getBoundingClientRect();
        const screenWidth = window.innerWidth;
        const isMobile = screenWidth < 768; // Adjust breakpoint as needed

        if (isMobile) {
          body.style.paddingLeft = '';
          body.style.paddingRight = '';
          body.style.paddingTop = '';
          body.style.paddingBottom = '';

          if (this.classList.contains("rotatebar-side-mobile-left")) {
            body.style.paddingLeft = `${rotatingBarWidth}px`;
          }
          if (this.classList.contains("rotatebar-side-mobile-right")) {
            body.style.paddingRight = `${rotatingBarWidth}px`;
          }
          if (this.classList.contains("rotatebar-side-mobile-top")) {
            body.style.paddingTop = `${rotatingBarHeight}px`;
          }
          if (this.classList.contains("rotatebar-side-mobile-bottom")) {
            body.style.paddingBottom = `${rotatingBarHeight}px`;
          }
        } 
        if (screenWidth > 768) {
          body.style.paddingLeft = '';
          body.style.paddingRight = '';
          body.style.paddingTop = '';
          body.style.paddingBottom = '';

          if (this.classList.contains("rotatebar-side-left")) {
            body.style.paddingLeft = `${rotatingBarWidth}px`;
          }
          if (this.classList.contains("rotatebar-side-right")) {
            body.style.paddingRight = `${rotatingBarWidth}px`;
          }
          if (this.classList.contains("rotatebar-side-top")) {
            body.style.paddingTop = `${rotatingBarHeight}px`;
          }
          if (this.classList.contains("rotatebar-side-bottom")) {
            body.style.paddingBottom = `${rotatingBarHeight}px`;
          }
        }
      }, 100); // Small delay to ensure visibility
    }
  }

  customElements.define('iconic-rotating-bar', IconicImageTextwithRotatingBar);
})();